export class Admin {

  static deserialize(dto: AdminDto): Admin {
    return new Admin(
      dto.id,
      dto.voornaam,
      dto.achternaam,
      dto.personeelsnummer,
      dto.email,
    );
  }

  constructor(
    private id: string,
    private voornaam: string,
    private achternaam: string,
    private personeelsnummer: string,
    private email: string,
  ) {
  }

  getId(): string {
    return this.id;
  }

  getVoornaam(): string {
    return this.voornaam;
  }

  getAchternaam(): string {
    return this.achternaam;
  }

  getNaam(): string {
    return `${this.getAchternaam()} ${this.getVoornaam()}`;
  }

  getPersoneelsnummer(): string {
    return this.personeelsnummer;
  }

  getEmail(): string {
    return this.email;
  }
}

export interface AdminDto {
  id: string;
  voornaam: string;
  achternaam: string;
  personeelsnummer: string;
  email: string;
}
